const KV2LV = (kv) => Object.keys(kv).map((item) => ({ value: item, label: kv[item] }));

// 需求目标
export const TARGET_TYPE_KV = {
  1: '工具搭建',
  2: '运营提效',
  3: '品牌曝光',
  4: '增粉拉新',
  5: '活跃复购',
  6: 'GMV提升',
  7: 'ROI优化',
  8: '其他（请描述）',
};
export const TARGET_TYPE = KV2LV(TARGET_TYPE_KV);

// 需求类型
export const DEMAND_TYPE_KV = {
  1: '投放提效工具',
  2: '私域运营工具',
  3: 'RTA工具',
  4: 'KOL管理服务',
  5: '数据服务',
  6: '代运营服务',
  7: '广告投放',
  8: '其他',
};
export const DEMAND_TYPE = KV2LV(DEMAND_TYPE_KV);

export const TENDER_NUM_KV = {
  3: '3个',
  5: '5个',
  7: '7个',
  '-1': '不限',
};
export const TENDER_NUM = KV2LV(TENDER_NUM_KV);

// 审核状态
export const ADUIT_STATUS_KV = {
  1: '待审核',
  2: '审核中',
  3: '审核通过',
  4: '审核未通过',
  5: '已取消',
};
export const ADUIT_STATUS = KV2LV(ADUIT_STATUS_KV);

// 需求状态
export const ORDER_STATUS_KV = {
  1: '审核',
  2: '分配',
  3: '竞标',
  4: '合同',
};
export const ORDER_STATUS = KV2LV(ORDER_STATUS_KV);

// 参与状态
export const JOIN_STATUS_KV = {
  1: '参与中',
  2: '未参与',
  3: '竞标中', // 已选中
  4: '评标中',
  5: '已中标', // 已中标
  6: '未中标',
};
export const JOIN_STATUS = KV2LV(JOIN_STATUS_KV);

// 客户预算
export const YU_SUAN_KV = {
  '0-1000': '0-1000',
  '1000-5000': '1000-5000',
  '5000-10000': '5000-10000',
  '10000-999999999': '10000以上',
};
export const YU_SUAN = KV2LV(YU_SUAN_KV);

// 没用到的：
// 服务商类型枚举值
